import React from 'react';
import memoize from 'memoize-one';

const columns = memoize(() => [
    {
        name: 'TEMA',
        selector: 'topic',
        cell: item => item.topic?.name || item.topic?.label || '-',
        sortable: true,
        grow: 2
    },
    {
        name: 'ÁREA DE NECESIDAD',
        selector: 'necessity_area',
        cell: item => item.necessityArea?.name || item.necessityArea?.label || '-',
        sortable: true,
        grow: 2
    },
    {
        name: 'NIVEL DE PROFUNDIDAD',
        selector: 'depth_level',
        cell: item => <span className="text-capitalize">{item.translatedDepthLevel || item.depthLevel || '-'}</span>,
        sortable: true,
        center: true
    },
    {
        name: 'NIVEL DE URGENCIA',
        selector: 'urgency_level',
        cell: item => <span className="text-capitalize">{item.translatedUrgencyLevel || item.urgencyLevel || '-'}</span>,
        sortable: true,
        center: true
    }
]);

export default columns;
